import Avatar from 'common/Avatar/Avatar'
import { observer } from 'mobx-react-lite'
import { UserRole, Workspace } from 'types'
import { getInitials } from 'utils'
import Styles from './WorkspacesMenu.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  workspace: Workspace
  isSelected?: boolean
}

export const WorkspaceMenuItemContent = observer(({ workspace, isSelected = false }: Props) => {
  const { name, logo_url: logoUrl, is_new: isNew, role, is_virtual_marketer } = workspace
  const isGuest = role === UserRole.GUEST
  const isMember = role === UserRole.MEMBER

  return (
    <div className={Styles.workspaceMenuItemContent}>
      <div className={Styles.menuItemContent}>
        <Avatar
          label={getInitials(name)}
          size={20}
          url={logoUrl}
          workspaceId={workspace.id}
          backgroundColor="#dfdfdf"
        />
        <Text variant="secondary" lineClamp={1} fontWeight={isSelected ? '500' : undefined}>
          {name}
        </Text>
      </div>
      {is_virtual_marketer && !isNew && !isGuest && !isMember && !isSelected && (
        <div className={Styles.pill}>Autopilot</div>
      )}
      {isGuest && !isNew && !isSelected && <div className={Styles.pill}>Guest</div>}
      {isMember && !isNew && !isSelected && <div className={Styles.pill}>Member</div>}
      {isNew && !isSelected && <div className={Styles.pill}>New</div>}
    </div>
  )
})
